/**
 * The audit stamps every replicated doc carries — written server-side on each
 * push (see the backend's `replicated.ts`), never edited in the app.
 *
 * The grid columns for them are built by `useAuditColumns`; this list lives in
 * a module of its own because `gridPreferences` also needs it and must not pull
 * a React hook into its module graph.
 */
export const AUDIT_FIELDS = [
    'createdBy',
    'updatedBy',
    'createdAt',
    'updatedAt'
] as const;

/**
 * `columnVisibilityModel` entries hiding the audit columns by default — spread
 * into each grid's own hidden-columns map. They are for looking something up
 * ("who changed this, when"), not for reading a record.
 */
export const HIDDEN_AUDIT_COLUMNS: Record<string, boolean> = Object.fromEntries(
    AUDIT_FIELDS.map((field) => [field, false])
);
